<template>
  <div>
    <!--<header>-->
      <!--<p>创客云商消息中心</p>-->
      <!--<img src="../../assets/images/setting.png" @click="goSet">-->
    <!--</header>-->
    <ul class="listUl">
      <li class="listLi" v-if="listData.notice_info" @click="listClick(1)">
        <div class="listBox">
          <img src="../../assets/images/message1.png">
          <ul>
            <li>官方通知</li>
            <li>{{listData.notice_info.msg}}</li>
          </ul>
        </div>
        <!--<b v-if="parseInt(item.tags) > 99">99+</b>-->
        <!--<b v-if="parseInt(item.tags) > 0 && parseInt(item.tags) <= 99">{{parseInt(item.tags)}}</b>-->
      </li>
      <li class="listLi" v-if="listData.person_notice" @click="listClick(2)">
        <div class="listBox">
          <img src="../../assets/images/message2.png">
          <ul>
            <li>个人消息</li>
            <li>{{listData.person_notice.msg}}</li>
          </ul>
        </div>
        <b v-if="parseInt(listData.person_notice.no_read) > 99">99+</b>
        <b v-if="parseInt(listData.person_notice.no_read) > 0 && parseInt(listData.person_notice.no_read) <= 99">{{parseInt(listData.person_notice.no_read)}}</b>
      </li>
      <li class="listLi" v-if="listData.logistics_info" @click="listClick(3)">
        <div class="listBox">
          <img src="../../assets/images/message3.png">
          <ul>
            <li>物流助手</li>
            <li>{{listData.logistics_info.msg}}</li>
          </ul>
        </div>
        <b v-if="parseInt(listData.logistics_info.no_read) > 99">99+</b>
        <b v-if="parseInt(listData.logistics_info.no_read) > 0 && parseInt(listData.logistics_info.no_read) <= 99">{{parseInt(listData.logistics_info.no_read)}}</b>
      </li>
      <li class="listLi" v-if="listData.service_info" @click="listClick(4)">
        <div class="listBox">
            <img src="../../assets/images/message5.png">
            <ul>
              <li>客服助手</li>
              <li>{{listData.service_info.msg}}</li>
            </ul>
        </div>
        <!--<b v-if="parseInt(listData.service_info.no_read) > 99">99+</b>-->
        <b v-if="parseInt(listData.service_info.no_read) > 0" style="width: 0.15rem;height: 0.15rem;border-radius: 0.15rem"></b>
      </li>
    </ul>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png">
    </div>
    <!--<p class="title"><span>——</span>&nbsp;&nbsp;群聊消息<span>&nbsp;&nbsp;——</span></p>-->
    <!--<ul class="listUl groupChat">-->
      <!--<li class="listLi" v-for="(item, index) of groupChatlist" :key="index" @click="listClick(index)">-->
        <!--<div class="listBox">-->
          <!--<div class="headerImg">-->
            <!--<img class="imgfour" v-if="item.imgList.length <= 4 && item.imgList.length > 0" v-for="(itemSon, idx) in item.imgList" :key="idx" :src="itemSon">-->
            <!--<img class="imgNine" v-if="item.imgList.length <= 9 && item.imgList.length > 4" v-for="(itemSon, idx) in item.imgList" :key="idx" :src="itemSon">-->
          <!--</div>-->
          <!--<ul>-->
            <!--<li>小喷泉专享群</li>-->
            <!--<li>还没有任何消息</li>-->
          <!--</ul>-->
        <!--</div>-->
        <!--<b v-if="parseInt(item.tags) > 99">99+</b>-->
        <!--<b v-else>{{parseInt(item.tags)}}</b>-->
      <!--</li>-->
    <!--</ul>-->
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'messageCenter',
  data () {
    return {
      listData: []
      // groupChatlist: [
      //   {
      //     imgList: [
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg')
      //     ],
      //     title: '小喷泉专享群',
      //     message: '还没有任何消息',
      //     tags: '98'
      //   },
      //   {
      //     imgList: [
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg'),
      //       require('../../assets/images/headerimage.jpg')
      //     ],
      //     title: '小喷泉专享群',
      //     message: '还没有任何消息',
      //     tags: '98'
      //   }
      // ]
    }
  },
  mounted: function () {
    window.scrollTo(0, 0)
    if (isWeixin()) {
      fenxiang({path: 'messagecenter'})
    }
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData () {
      var url = 'Msg/Mallmsg/getMessageList'
      var that = this
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.listData = res.data
        }
      })
    },
    listClick: function (id) {
      var that = this
      if (id == 1) {
        if (this.listData.notice_info.have_msg == 1) {
          this.$router.push('/noticemessage')
        } else {
          this.$dialog.confirm({
            title: '暂无消息',
            message: '您还没有任何消息\n' +
              '可以去看看有哪些想买的',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去逛逛'
          }).then(() => {
            // on confirm
            that.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          }).catch(() => {
            // on cancel
          })
        }
      } else if (id == 2) {
        if (this.listData.person_notice.have_msg == 1) {
          this.$router.push('/personmessage')
        } else {
          this.$dialog.confirm({
            title: '暂无消息',
            message: '您还没有任何消息\n' +
              '可以去看看有哪些想买的',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去逛逛'
          }).then(() => {
            // on confirm
            that.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          }).catch(() => {
            // on cancel
          })
        }
      } else if (id == 3) {
        if (this.listData.logistics_info.have_msg == 1) {
          this.$router.push('/logisticsMessage')
        } else {
          this.$dialog.confirm({
            title: '暂无消息',
            message: '您还没有任何消息\n' +
              '可以去看看有哪些想买的',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '去逛逛'
          }).then(() => {
            // on confirm
            that.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          }).catch(() => {
            // on cancel
          })
        }
      } else if (id == 4) {
        // this.$toast('客服')
        if (parseInt(this.listData.service_info.no_read) > 0) {
          var url = 'Msg/Mallmsg/updateReadStatus'
          var data = {
            msgtype: 3
          }
          customRequestAjax.post(url, data)
            .then(res => {
              if (res.data.code === 200) {
                this.listData.service_info.no_read = 0
              }
            })
        }
        kefu()
      }
    },
    goSet: function () {
      this.$router.push('/setting')
    },
    homeClick: function () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
  header {
    height: 0.38rem;
    background: #fff;
    display: flex;
    display: -o-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
    padding: 0 0.13rem 0 0.11rem;
    p {
      font-size: 0.13rem;
      color: #3F3F3F;
    }
    img {
      width: 0.17rem;
      height: 0.17rem;
    }
  }
  .listLi {
    height: 0.7rem;
    margin: 0.1rem 0.11rem 0.1rem;
    padding: 0 0.11rem;
    border-radius: 0.04rem;
    background: #fff;
    display: flex;
    display: -o-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
    &:active {
      background: #f2f3f5;
    }
    .listBox {
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      img {
        width: 0.44rem;
        height: 0.44rem;
        margin-right: 0.17rem;
      }
      ul {
        li {
          &:first-child {
            font-size: 0.15rem;
            color: #222222;
            margin-bottom: 0.03rem;
            font-weight:600;
          }
          &:nth-child(2) {
            font-size: 0.12rem;
            color: #6C6C6C;
            font-weight:400;
            max-width: 2.4rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
    b{
      display: flex;
      justify-content: center;
      align-items: center;
      /* padding: 0 0.04rem 0 0.05rem; */
      background: #FC0324;
      color: #fff;
      border-radius: 0.15rem;
      font-size: 0.1rem;
      font-weight: 300;
      min-width: 0.15rem;
      height: 0.15rem;
    }
  }
  .title {
    color: #222222;
    font-size: 0.18rem;
    text-align: center;
    padding-top: 0.03rem;
    display: flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: center;
    -moz-justify-content: center;
    -o-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    span {
      display: block;
      color:#DBDBDB
    }
  }
  .groupChat {
    .listBox {
      .headerImg {
        width: 0.54rem;
        height: 0.54rem;
        display: flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        flex-wrap: wrap-reverse;
        -ms-flex-wrap: wrap-reverse;
        -webkit-flex-wrap: wrap-reverse;
        -moz-flex-wrap: wrap-reverse;
        -o-flex-wrap: wrap-reverse;
        flex-direction: row-reverse;
        -ms-flex-direction: row-reverse;
        -webkit-flex-direction: row-reverse;
        -moz-flex-direction: row-reverse;
        -o-flex-direction: row-reverse;
        align-items: center;
        -ms-align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
        align-content: center;
        -ms-align-content: center;
        -webkit-align-content: center;
        -moz-align-content: center;
        -o-align-content: center;
        justify-content: center;
        -ms-justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -o-justify-content: center;
        margin-right: 0.17rem;
        img {
          margin-right: 0;
          padding-right: 0.01rem;
          padding-bottom: 0.01rem;
          &.imgfour {
            width: 50%;
            height: 50%;
          }
          &.imgNine {
            width: 30%;
            height: 30%;
          }
        }
      }

    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right:0.17rem;
    bottom:0.8rem;
    width:0.4rem;
    height:0.4rem;
    border-radius: 50%;
    background:rgba(255,255,255,1);
    box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -webkit-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -moz-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -ms-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    -o-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/message/messageCenter.vue